export const getHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  Accept: "text/plain",
});
